<script>
import { SuccessIcon } from '../../icons'

export default {
  name: 'CopiedStatus',
  components: { SuccessIcon }
}
</script>

<template>
  <div class="status-copied">
    <SuccessIcon className="status-copied-success-icon"/>
    Copied
  </div>
</template>

<style scoped lang="scss">
.status-copied {
  color: $fontColorSuccess;
}

.status-copied-success-icon {
  vertical-align: -6px;
  margin-right: 4px;
}
</style>
